import { compose } from 'redux';
import { WithFetchDatasByIdFromCMS, WithFetchDatasByIdFromCMSInputProps } from 'modules/shared-cms/hocs';
import { TrendBlocContainerOwnProps } from 'modules/shared-cms-catalogue/components';
import { WithFetchProducts } from 'modules/shared-cms-catalogue/hocs';
import { CmsProductListProps } from 'modules/shared-cms-catalogue/types';

import { QUERY } from './tendance-catalogue-query';
import { TendanceCatalogueLoader } from './tendance-catalogue-component-loader';

const enhancer = compose<React.ComponentType<WithFetchDatasByIdFromCMSInputProps>>(
    WithFetchDatasByIdFromCMS<TrendBlocContainerOwnProps & CmsProductListProps>(
        QUERY,
        TendanceCatalogueLoader,
        'findTendanceCatalogueContent',
    ),
    WithFetchProducts(TendanceCatalogueLoader),
);

export default enhancer;
